const NAIROBI_FORMATTER = (() => {
  try {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Africa/Nairobi',
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return null;
  }
})();

function nairobiTimeParts(date) {
  if (!NAIROBI_FORMATTER) {
    throw new Error('Intl.DateTimeFormat unavailable');
  }
  const parts = Object.fromEntries(
    NAIROBI_FORMATTER.formatToParts(date)
      .filter((p) => p.type !== 'literal')
      .map((p) => [p.type, p.value]),
  );
  return {
    year: parseInt(parts.year, 10),
    month: parseInt(parts.month, 10),
    day: parseInt(parts.day, 10),
    hour: parseInt(parts.hour, 10) % 24,
    minute: parseInt(parts.minute, 10),
    second: parseInt(parts.second, 10),
  };
}

/** @returns {'day' | 'night'} */
export function celestialModeAt(date = new Date()) {
  try {
    const { hour } = nairobiTimeParts(date);
    return hour >= 6 && hour < 18 ? 'day' : 'night';
  } catch {
    return 'day';
  }
}

/** Milliseconds until the next 06:00 or 18:00 Nairobi boundary, plus a 1s buffer. */
export function msUntilNextCelestialBoundary(from = new Date()) {
  const BUFFER_MS = 1000;
  try {
    const { hour, minute, second } = nairobiTimeParts(from);
    const target = hour < 6 ? 6 : hour < 18 ? 18 : 6;
    const hoursUntil = (target - hour + 24) % 24;
    const ms =
      hoursUntil * 3_600_000 -
      minute * 60_000 -
      second * 1000 -
      (from.getTime() % 1000) +
      BUFFER_MS;
    return Math.max(ms, BUFFER_MS);
  } catch {
    return 12 * 60 * 60 * 1000 + BUFFER_MS;
  }
}

export { nairobiTimeParts };
